export const showAddFeedback = (state, flag) => {
	state.showAddFeedback = flag
}

export const setFeedbackList = (state, data) => {
    state.feedbackList.data = data.data.data
}